import React from 'react'
import SupplyBillAgreeIco from '../../view/items/SupplyBillAgreeIco'
import { useState } from 'react';
import MyModal from '../../../../UI/modal/MyModal';
import AgreeEconomistBillItemForm from './AgreeEconomistBillItemForm';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const AgreeEconomistButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження економістом'}
            ico={<MonetizationOnIcon />}
            value={supplyBillItem.isAgreeEconomist}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeEconomistBillItemForm
                    // supplyOrderId={supplyOrderId}
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeEconomistButton